import React, { useState } from "react";
import FlipCard from "./FlipCard";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

/**
 * Single-card overlay for VideoBox — Lucky 7 (lucky7 / plucky7 / lucky7eu / lucky7eu2) and
 * Amar Akbar Anthony (aaa / aaa2) in the reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     (.dealer-name "Cards" — not on aaa2 — + <div><span><img></span></div>). Styled by index.css.
 * Like the reference: hidden while the card is a back ("1"); the shuffle handle toggles it.
 */
export default function Lucky7CardsOverlay({ card, dealerName = true }) {
  const [showCards, setShowCards] = useState(true);
  const cards = String(card ?? "").split(",").map((c) => c.trim());
  if (!String(card ?? "").length) return null;
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {dealerName && (
          <>
            <div className="dealer-name">Cards</div>{" "}
          </>
        )}
        <div>
          <span>
            <FlipCard src={`${IMG}/${cards[0]}.png`} alt="" />
          </span>
        </div>
      </div>
    </div>
  );
}
